export default __webpack_public_path__ + "static/media/logo.b72ec31d.png";